module.exports = {"list_title":"Tag Management","tt_id":"Tag Number","tt_quantity":"Quantity","tt_time":"Created Time"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US-plan.json
// module id = 600
// module chunks = 21